import React, { useRef, useEffect } from 'react';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const UNIT_OPTIONS = [
  { value: 'both', label: 'quote_builder_widget.unit_option_both' },
  { value: 'mm', label: 'quote_builder_widget.unit_option_mm' },
  { value: 'in', label: 'quote_builder_widget.unit_option_in' },
];

const ConfigurationSection = ({
  domains,
  setDomains,
  unitOption,
  setUnitOption,
  addDomainFormVisible,
  setAddDomainFormVisible,
  addDomainFormHighlighted,
  setAddDomainFormHighlighted,
  newDomain,
  setNewDomain,
}) => {
  const domainInputRef = useRef();

  useEffect(() => {
    if (addDomainFormVisible && domainInputRef.current) {
      domainInputRef.current.focus();
    }
  }, [addDomainFormVisible]);

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  const addToDomains = () => {
    if (newDomain.split('.').length === 1) {
      return;
    }
    setDomains((previous) => previous.concat([newDomain]).filter(onlyUnique));
    setAddDomainFormHighlighted(false);
    setAddDomainFormVisible(false);
    setNewDomain('');
  };

  const removeFromDomains = (domain) => {
    setDomains((previous) => previous.filter((d) => d !== domain));
  };

  const domainWithHttp = (domain) => `https://${domain}`;

  return (
    <div>
      <h4 className={styles.sectionHeader}>
        {t('quote_builder_widget.section_configuration')}
      </h4>

      {/* Domains */}
      <div className={styles.fieldGroup}>
        <label className={styles.label}>{t('quote_builder_widget.domains')}</label>
        <p className={styles.helpText}>{t('quote_builder_widget.domains_info')}</p>

        <div className={addDomainFormHighlighted ? styles.domainHighlighted : undefined}>
          {domains.length > 0 && (
            <div className={styles.domainList}>
              {domains.map((domain) => (
                <div key={domain} className={styles.domainItem}>
                  <span className={styles.domainDisplay}>
                    {domainWithHttp(domain)}
                  </span>
                  <button
                    type="button"
                    className={`btn btn-sm ${styles.domainDeleteButton}`}
                    onClick={() => removeFromDomains(domain)}
                  >
                    <i className="fa fa-trash-o" aria-hidden="true"></i> {t('quote_builder_widget.remove')}
                  </button>
                </div>
              ))}
            </div>
          )}

          {!addDomainFormVisible && (
            <button
              className="btn simple-btn"
              onClick={(event) => {
                event.preventDefault();
                setAddDomainFormVisible(true);
              }}
            >
              <i className="fa fa-plus-square-o" aria-hidden="true"></i> {t('quote_builder_widget.add_domain')}
            </button>
          )}

          {addDomainFormVisible && (
            <div className={`form-inline ${styles.addDomainForm}`}>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">https://</div>
                  <input
                    type="text"
                    className="form-control"
                    size="35"
                    ref={domainInputRef}
                    value={newDomain}
                    placeholder="www.example.com"
                    onChange={(event) => setNewDomain(event.target.value)}
                  />
                </div>
              </div>
              <button type="button" className={`btn simple-btn ${styles.addDomainSaveButton}`} onClick={addToDomains}>
                {t('quote_builder_widget.save')}
              </button>
              <button className={`btn ${styles.addDomainCancelButton}`} type="button" onClick={() => setAddDomainFormVisible(false)}>
                {t('quote_builder_widget.cancel')}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Unit Selection */}
      <div className={styles.fieldGroup}>
        <label className={styles.label}>{t('quote_builder_widget.unit_option')}</label>
        <p className={styles.helpText}>{t('quote_builder_widget.unit_option_info')}</p>
        <select
          className={`form-control ${styles.unitSelect}`}
          value={unitOption}
          onChange={(event) => setUnitOption(event.target.value)}
        >
          {UNIT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {t(option.label)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ConfigurationSection;
